import _ from 'underscore'
import {MONTH_NAME_KEYS, ABBR_DAY_NAME_KEYS, SHORT_DAY_NAME_KEYS} from './constants'
import {getLocalStorage} from '../../util/LocalStorage'
import {createArrayOfObjectFromMap} from '../../atUtils'
import messageResource from '../../messageResource'

export function getMonthNameKey(monthNum) {
    return MONTH_NAME_KEYS[monthNum]
}

export function getAbbrDayNameKey(dayNum) {
    return ABBR_DAY_NAME_KEYS[dayNum]
}

export function getShortDayNameKey(dayNum) {
    return SHORT_DAY_NAME_KEYS[dayNum]
}

export function isSameDate(d1, d2) {
    return d1.getDate() === d2.getDate() &&
           d1.getMonth() === d2.getMonth() &&
           d1.getFullYear() === d2.getFullYear()
}

export function isSameMonth(d1, d2) {
    return d1.getMonth() === d2.getMonth() &&
           d1.getFullYear() === d2.getFullYear()
}

export function dateWithoutTime(date) {
    let d = new Date(date)
    d.setHours(0, 0, 0, 0)
    return d
}

function getWorkScheduleNumForDate(date, workSchedules) {
    return _.findLastIndex(workSchedules, ws => ws.effectiveDate <= date)
}

export class DatesIterator {
    constructor(dateFrom, dateTo) {
        this.yFrom = dateFrom.getFullYear()
        this.mFrom = dateFrom.getMonth()
        this.dFrom = dateFrom.getDate()
        this.nextDate = Date.create(this.yFrom, this.mFrom, this.dFrom)
        this.dateTo = dateTo != null ? dateTo.truncateTime() : null
    }

    next() {
        let result = this.nextDate
        this.dFrom++
        this.nextDate = Date.create(this.yFrom, this.mFrom, this.dFrom)
        return result
    }

    hasNext() {
        return this.dateTo && this.nextDate <= this.dateTo
    }
}

export class DayIteratorWithWorkSchedule extends DatesIterator {
    constructor(dateFrom, dateTo, workSchedules) {
        super(dateFrom, dateTo)
        this.nextDate = Date.create(this.yFrom, this.mFrom, this.dFrom)
        this.effectiveScheduleNum = getWorkScheduleNumForDate(dateFrom, workSchedules)
        this.workSchedules = workSchedules
    }

    next() {
        if (this.workSchedules[this.effectiveScheduleNum + 1] && isSameDate(this.nextDate, this.workSchedules[this.effectiveScheduleNum + 1].effectiveDate)) {
            this.effectiveScheduleNum++
        }
        let nonWorking = this.workSchedules[this.effectiveScheduleNum].dayDurations[this.nextDate.getDay()] === 0
        let result = {
            date: this.nextDate,
            nonWorking,
        }
        this.dFrom++
        this.nextDate = Date.create(this.yFrom, this.mFrom, this.dFrom)
        return result
    }
}

export class MonthIterator {
    constructor(dateFrom, dateTo) {
        this.yFrom = dateFrom.getFullYear()
        this.mFrom = dateFrom.getMonth()
        this.nextDate = new Date(this.yFrom, this.mFrom)
        this.dateTo = dateTo
    }

    next() {
        let result = this.nextDate
        this.mFrom++
        this.nextDate = new Date(this.yFrom, this.mFrom)
        return result
    }

    hasNext() {
        return this.dateTo && this.nextDate <= this.dateTo
    }
}


export function createHolidayListObject(key, value) {
    return {
        date: key,
        name: value.name
    }
}

export const getSortedArrayFromObjectByDate = (object, isAsc) => {
    let sortedKeys = Object.keys(object).sort((a, b) => {
        return isAsc ? ascSort(a, b): descSort(a, b)
    })

    return createArrayOfObjectFromMap(object, createHolidayListObject, sortedKeys)
}

export const getSortedArrayFromObjectByName = (object, isAsc) => {
    let sortedKeys = Object.keys(object).sort((a, b) => {
        return isAsc ? ascSort(object[a].name.toLowerCase(), object[b].name.toLowerCase())
                     : descSort(object[a].name.toLowerCase(), object[b].name.toLowerCase())
    })

    return createArrayOfObjectFromMap(object, createHolidayListObject, sortedKeys)
}

export const sortHolidaysArray = (array, isAsc) => {
    return array.sort((a, b) => {
        return isAsc ? ascSort(a.date, b.date) : descSort(a.date, b.date)
    })
}

const ascSort = (a, b) => {
    return a > b ? -1 : a < b ? 1 : 0;
}

const descSort = (a, b) => {
    return a < b ? -1 : a > b ? 1 : 0;
}

export const createYearsListForSelector = (yearFrom, yearTo) => {
    let list = []

    for (let i = yearFrom; i <= yearTo; i++) {
        list.push({year: i})
    }

    return list.reverse()
}

export const convertEffectiveDateInWorkSchedule = (workSchedules) => {
    workSchedules.forEach((schedule) => {
        schedule['effectiveDate'] = new Date(schedule.effectiveDate)
    })

    return workSchedules
}

export const validateFile = (file) => {
    if(file.size === 0 || (!!file.type && file.type !== 'text/calendar') || file.name.split('.')[1] !== 'ics') {
        return messageResource.getMessage('work_schedule.ical_load_file_filed')
    }

    return null
}



// WEBPACK FOOTER //
// ./web/js/administration/workSchedule/utils.js